import React, { useEffect, useState } from 'react';
import Checkoutorders from '../components/Orders/checkoutorders';
import Navigation from '../components/nav';
import { getCookie} from '../utils/cookieUtils';
import { useLocation } from 'react-router-dom';

function Checkout() {
  // const [totalPrice, setTotalPrice] = useState(0); // Initialize as 0
  const location = useLocation();
  const totalPrice = location.state.totalPrice || 0;


  // useEffect(() => {
  //   // Retrieve the total price from the "totalprice" cookie
  //   const cartItemsString = getCookie("totalprice");

  //   if (cartItemsString) {
  //     // Parse the value if the cookie exists
  //     const parsedTotalPrice = JSON.parse(cartItemsString);
  //     setTotalPrice(parsedTotalPrice);
  //   }
  // }, []); // Run this effect once when the component mounts

  

  

  return (
    <div className='mt-20'> 
    <Navigation />
    
    <div className='flex md:mx-auto md:flex-row flex-col justify-around'>
      {/* Form Section */}
       <Checkoutorders />

     
    </div>
    </div>
  );
}

export default Checkout;
